import { BaseAPI } from './BaseAPI.js'
import { UserDevice } from '../types/index.js'

export default class UserDevicesAPI extends BaseAPI<UserDevice> {
  override get resource(): string {
    return '/userDevices'
  }

  public async getSipCredentials(
    id: number,
  ): Promise<{ attributes: { username: string; password: string } }> {
    const result = await this._client.get(`/userDevices/${id}/credentials`)
    return result.data
  }
}
